<app-command #command></app-command>